import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { IntegrityMonitorCustomRuleActionsFormWebComponent } from '../../imCustomRuleActionsForm';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../../webcomponents.constants';
import {
  getIntegrityMonitorOsTypes,
  getIntegrityMonitorRulesFileAttributes,
  IntegrityMonitorPlatform,
} from '../../../../common/utils/types';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { GzDropdownWebComponent } from '../../../../../ui/gzDropdown';
import { RequiredValidator } from '../../../../../ui/gzForm/validators/required.validator';
import { IntegrityMonitorFilePathFormFieldWebComponent } from '../../imCustomRuleFilePathFormField/IntegrityMonitorFilePathFormFieldWebComponent';
import { CustomRuleValidators } from '../../common/validators';
import { IMConstants } from '../../../../common/utils/IMConstants';

export class IntegrityMonitorFileRuleFormView extends BaseWebComponentView {
  public formGroup: FormGroup;

  public dom: {
    $securitySubtitle: GzTitleWebComponent;

    $osFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;
    $keysFormField: GzFormFieldWebComponent<IntegrityMonitorFilePathFormFieldWebComponent, string[]>;

    $actionsForm: IntegrityMonitorCustomRuleActionsFormWebComponent;
  };

  getDomElements() {
    this.dom = {
      $securitySubtitle: this.shadow.querySelector('#security-subtitle'),

      $osFormField: this.shadow.querySelector('#os-form-field'),
      $keysFormField: this.shadow.querySelector('#keys-form-field'),

      $actionsForm: this.shadow.querySelector(WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM),
    };

    this.getTranslations();
    this.setTranslatedStrings();
    this.createFormGroup();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.customRuleForm;
  }

  setTranslatedStrings() {
    this.dom.$securitySubtitle.innerText = this.translations.securitySubtitle;

    this.dom.$osFormField.label = this.translations.osLabel;
    this.dom.$osFormField.Input.placeholder = this.translations.osPlaceholder;

    this.dom.$keysFormField.label = this.translations.entityTypeFile.keysLabel;
    this.dom.$keysFormField.Input.placeholderFirst = this.translations.entityTypeFile.keysFirstPlaceholder;
    this.dom.$keysFormField.Input.placeholderSecond = this.translations.entityTypeFile.keysSecondPlaceholder;
  }

  initEnumFilter() {
    this.dom.$osFormField.Input.options = getIntegrityMonitorOsTypes(this.dependencies.translateFn)
      .filter(os => os.implemented)
      .map(os => {
        return {
          title: os.label,
          value: os.value,
        };
      });
  }

  createFormGroup() {
    this.dom.$osFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];
    this.dom.$keysFormField.Validators = [
      CustomRuleValidators.atLeastOneValidator(this.translations.entityTypeFile.errorAtLeastOneKey),
      CustomRuleValidators.atMostValidator(
        IMConstants.INTEGRITY_MONITOR_RULE_FILE_MAX_ALLOWED_KEYS,
        this.translations.entityTypeFile.errorTooManyKeys
      ),
    ];

    this.dom.$keysFormField.Input.maxValues = IMConstants.INTEGRITY_MONITOR_RULE_FILE_MAX_ALLOWED_KEYS;

    this.dom.$keysFormField.Input.validator = CustomRuleValidators.pathValidator(
      () => this.dom.$osFormField.value as IntegrityMonitorPlatform,
      false,
      false,
      this.translations.validationErrors
    );

    this.dom.$keysFormField.Input.getOs = () => this.dom.$osFormField.value as IntegrityMonitorPlatform;
    this.dom.$keysFormField.Input.translations = this.translations.validationErrors;

    this.dom.$osFormField.initialValue = '';
    this.dom.$keysFormField.initialValue = [];

    this.formGroup = FormGroup.build({
      os: this.dom.$osFormField,
      keys: this.dom.$keysFormField,
    });
  }

  buildSuccessView(data: any) {
    this.dom.$actionsForm.injectDependencies(this.dependencies);
    this.dom.$actionsForm
      .start()
      .catch(console.warn)
      .then(() => {
        this.dom.$actionsForm.options = getIntegrityMonitorRulesFileAttributes(this.dependencies.translateFn);
        this.formGroup.addFormChild(['attributes'], this.dom.$actionsForm.controller.view.formGroup);
      });

    this.initEnumFilter();
  }

  buildErrorView(error: any) {}
}
